import React from "react";
import MaratiLogo from "assets/images/marati_icon.png";
import { useAppScope } from "master";

export const MwcdLogoComopent = ({ customClass = "marathi-footer-logo" }) => {
    const { isMWCD } = useAppScope();

    return (
        isMWCD && (
            <div className={customClass}>
                <img className="marati_logo" src={MaratiLogo} alt="Marathi Logo" />
            </div>
        )
    );
};